<template>
  <div class="processed-by mt-1">Check-in</div>
</template>

<script>
export default {}
</script>
